import { render } from "./wf-sd.vue?vue&type=template&id=b6ea0924&scoped=true"
import script from "./wf-sd.vue?vue&type=script&lang=js"
export * from "./wf-sd.vue?vue&type=script&lang=js"

import "./wf-sd.vue?vue&type=style&index=0&id=b6ea0924&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6ea0924"]])

export default __exports__